<!-- Modal Body -->
<div class="modal-header">
    <h5 class="modal-title" id="qrModalLabel">QR Code Setup</h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body text-center">
    <!-- QR Code Display -->
    <div #qrcodeContainer>
      <qrcode
        [qrdata]="'https://' + qrItem.sub_domain + '.menuload.com'"
        [colorDark]="qrColor"
        [width]="256"
        [elementType]="'svg'">
      </qrcode>
    </div>

  
    <!-- Color Picker -->
    <div class="mt-3">
      <label for="qrColorPicker">Change QR Code Color:</label>
      <input 
        id="qrColorPicker" 
        type="color" 
        [(ngModel)]="qrColor" 
        class="form-control form-control-color w-50 m-auto">
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="downloadQrCode()">Download QR Code</button>
  </div>